import { render, staticRenderFns } from "./ad-tip.vue?vue&type=template&id=2ca545e4&scoped=true&"
import script from "./ad-tip.vue?vue&type=script&lang=js&"
export * from "./ad-tip.vue?vue&type=script&lang=js&"
import style0 from "./ad-tip.vue?vue&type=style&index=0&id=2ca545e4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ca545e4",
  null
  
)

export default component.exports